// @core/api/endpoints/subscription/get_bundle_subscription_preview.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetBundleSubscriptionPreviewRequest,
  GetBundleSubscriptionPreviewResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Preview bundle subscription pricing
 * Calculates the pricing for a bundle subscription including discounts and per-product breakdown.
 * @public This endpoint does not require authentication
 */
export async function GetBundleSubscriptionPreview(
  bundle_id: string,
  data: GetBundleSubscriptionPreviewRequest,
  options?: RequestOptions
): Promise<GetBundleSubscriptionPreviewResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/bundles/:bundle_id/preview`;
  requestPath = requestPath.replace(':bundle_id', encodeURIComponent(bundle_id));
  const requestOptions = { ...options, skipAuth: true };
  return client.post<GetBundleSubscriptionPreviewResponse>(requestPath, data, requestOptions);
}
